import { call, put } from 'redux-saga/effects';
import { alertPush } from '../../alert';
import { ErrorHandlerFetch, getErrorData } from '../actions';
import { SagaIterator } from 'redux-saga';

export function* handleErrorSaga(action: ErrorHandlerFetch): SagaIterator {
    const { processingType, extraOptions, error } = action.payload;

    if (extraOptions) {
        const { params, type, actionError } = extraOptions;

        if (type) {
            switch (type) {
                default:
                    window.console.log(`Unexpected action with type: ${type}`);
                    break;
            }
        }

        if (actionError) {
            params ? yield put(actionError(params)) : yield put(actionError(error));
        }
    }

    switch (processingType) {
        case 'alert':
            yield call(handleAlertError,  error);
            break;
        case 'console':
            yield call(handleConsoleError, error);
            break;
        default:
            break;
    }


    yield put(getErrorData());
}

function* handleAlertError(error: any) {
    yield put(alertPush({
        codeConfig: error?.codeConfig,
        message: error?.message,
        code: error?.code,
        type: 'error',
    }));
}

function* handleConsoleError(error: any) {
    yield call(window.console.error, error.message[0]);
}
